export default "__VITE_ASSET__ChqlpyFs__"